<script setup lang="ts">
interface Props {
  color?: string;
}

const props = withDefaults(defineProps<Props>(), {
  color: '#ababab',
});
</script>

<template>
  <div
    class="p-timeline-marker"
    :style="{ '--marker-color': props.color }"
  ></div>
</template>

<style scoped>
.p-timeline-marker {
  background-color: var(--marker-color);
  border-color: var(--marker-color);
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
</style>
